import { useEffect, useState } from 'react'
import { useCompanion } from '@/hooks/useCompanion'
import type { CompanionMeter } from '@/lib/companion'
import { WhyTapModal } from '@/components/WhyTapModal'

export function RhythmMeterWhy({ meter, personId }: { meter: CompanionMeter; personId: string }) {
  const { enabled, scope } = useCompanion()
  const [openFor, setOpenFor] = useState<string | null>(null)
  const contextKey = JSON.stringify([scope, personId])
  // Re-enabling or switching actors/persons must never reopen without a fresh tap.
  useEffect(() => { setOpenFor(null) }, [enabled, contextKey])
  if (!enabled || scope?.personId !== personId) return null
  return <>
    <button type="button" aria-label={`Why this ${meter.label.toLowerCase()} meter?`} aria-haspopup="dialog"
      className="min-h-11 min-w-11 text-caption text-text-secondary rounded-full hover:bg-bg-elevated"
      onClick={() => setOpenFor(contextKey)}>?</button>
    {openFor === contextKey && <WhyTapModal meter={meter} personId={personId} onClose={() => setOpenFor(null)} />}
  </>
}
